import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function amkaValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let amka = control?.value;
    if (!amka || typeof amka != 'string') return null;

    if (!amka.match(/^\d{11}$/) || amka == '00000000000') return { amka: true };

    var iSum = 0;
    for (var i = 1; i <= amka.length; i++) {
      var iDigit = parseInt(amka.charAt(i - 1), 10);
      if (i % 2 === 0) {
        iDigit *= 2;
        if (iDigit > 9) {
          iDigit -= 9;
        }
      }
      iSum += iDigit;
    }
    return iSum % 10 != 0 ? { amka: true } : null;
  };
}
